import validators from './index';

export default {
  isName: (value: string) => !validators.isName(value),
  isLongName: (value: string) => !validators.isLongName(value),
  isEmail: (value: string) => !validators.isEmail(value),
  isDate: (value: string) => !validators.isDate(value),
  isBirthday: (value: string) => !validators.isBirthday(value),
  isBirthdayYearFirst: (value: string) =>
    !validators.isBirthdayYearFirst(value),
  isBirthdayDayFirst: (value: string) => !validators.isBirthdayDayFirst(value),
  isPhone: (value: string) => !validators.isPhone(value),
  isAddress: (value: string) => !validators.isAddress(value),
  isCurrency: (value: string) => !validators.isCurrency(value),
  isSalary: (value: number) => !validators.isSalary(value),
  isHourlyRate: (value: string) => !validators.isHourlyRate(value),
  isHoursPerWeek: (value: number) => !validators.isHoursPerWeek(value),
  isAnnualIncome: (value: number) => !validators.isAnnualIncome(value),
  isOtherIncome: (value: number) => !validators.isOtherIncome(value),
  isSecurityNumber: (value: string) => !validators.isSecurityNumber(value),
  isSocialInsuranceNumber: (value: string) =>
    !validators.isSocialInsuranceNumber(value),
  isZip: (value: string) => !validators.isZip(value),
  isExtendedZip: (value: string) => !validators.isExtendedZip(value),
  isEmployer: (value: string) => !validators.isEmployer(value),
  isJobTitle: (value: string) => !validators.isJobTitle(value),
  isCity: (value: string) => !validators.isCity(value),
  isMileage: (value: number) => !validators.isMileage(value),
  isNotEmpty: (value: string) => !validators.isNotEmpty(value),
  isApt: (value: string) => !validators.isApt(value),
  isDriverLicenseNumber: (value: string) =>
    !validators.isDriverLicenseNumber(value),
  isMortgage: (value: number) => !validators.isMortgage(value),
  isBoolean: (value: string) => !validators.isBoolean(value),
  isVin: (value: string) => !validators.isVin(value),
  isFullAddress: (value: Parameters<typeof validators.isFullAddress>[0]) =>
    !validators.isFullAddress(value),
  isYearWithinRange: (minYear: number, maxYear: number) => (value: string) =>
    !validators.isYearWithinRange(minYear, maxYear)(value),
  isValidUpstartSchoolName: (value: string) =>
    !validators.isValidUpstartSchoolName(value),
};
